import { useState, useCallback, useMemo } from 'react';
import DeclinedCallIcon from '@/assets/images/common/svg/declined-call.svg?react';
import AudioAcceptsIcon from '@/assets/images/common/svg/audio-accepts.svg?react';
import VideoAcceptsIcon from '@/assets/images/common/svg/video-accepts.svg?react';
import AcceptsLoadingIcon from '@/assets/images/common/svg/accepts-loading.svg?react';
import { ChatMessagePayloadType } from '@/contexts/chat/scripts/hooks/useChatMessages/types';
import { useColorAnalyzer } from '@/scripts/hooks/useColorAnalyzer';
import { useChatContext } from '@/contexts/chat/context';
import CallIcon from './images/call-icon.svg?react';
import styles from './index.module.scss';

const NotificationContent = () => {
  const {
    chatMediaCall: { chatMediaInfo },
    mediaLoading,
    mediaJoin,
    mediaDeclined,
  } = useChatContext();
  const [selected, setSelected] = useState('' as 'accept' | 'decline');

  const payload_type = useMemo(() => chatMediaInfo?.payload_type, [chatMediaInfo]);

  const bgColor = useColorAnalyzer(chatMediaInfo?.chat?.user?.avatar, {
    format: 'rgb',
    samplingStep: 8,
    // alpha: 0.5,
  });

  const handleDeclined = useCallback(() => {
    setSelected('decline');
    mediaDeclined();
  }, [mediaDeclined]);

  const handleAccept = useCallback(async () => {
    setSelected('accept');
    await mediaJoin();
  }, [mediaJoin]);

  return (
    <div className={styles.notificationContent} style={{ backgroundColor: bgColor }}>
      <div className={styles.sendInfo}>
        <MyAvatar
          className={styles.avatar}
          src={chatMediaInfo?.chat?.user?.avatar as string}
          info={chatMediaInfo?.chat?.user}
        ></MyAvatar>
        <div className={styles.info}>
          <div className={styles.name}>{chatMediaInfo?.chat?.user?.name}</div>
          <div className={styles.desc}>
            <div className={styles.ringing}>
              <CallIcon />
              <div className={styles.textBar}>
                {payload_type === ChatMessagePayloadType.MEDIA_AUDIO_CALL
                  ? 'Voice Call...'
                  : 'Video Call...'}
              </div>
            </div>
          </div>
        </div>
        <div className={styles.operation}>
          {selected !== 'accept' && (
            <div className={styles.operateBtn}>
              <DeclinedCallIcon onClick={handleDeclined}></DeclinedCallIcon>
              <div className={styles.operateTxt}>Decline</div>
            </div>
          )}
          {selected !== 'decline' && (
            <div className={styles.operateBtn}>
              {mediaLoading ? (
                <AcceptsLoadingIcon style={{ cursor: 'initial' }}></AcceptsLoadingIcon>
              ) : payload_type === ChatMessagePayloadType.MEDIA_AUDIO_CALL ? (
                <AudioAcceptsIcon onClick={handleAccept}></AudioAcceptsIcon>
              ) : (
                <VideoAcceptsIcon onClick={handleAccept}></VideoAcceptsIcon>
              )}
              <div className={styles.operateTxt}>Accept</div>
            </div>
          )}
        </div>
      </div>
      {/* <div className={styles.groupInfo}>
        <div className={styles.memberCount}>2 other(s) in the call:</div>
        <div className={styles.members}>
          <MyAvatar src=""></MyAvatar>
        </div>
      </div> */}
    </div>
  );
};

export default NotificationContent;
